import panelModule from "./r2PanelModule"
import panelView from "./panelHeaderButtons.html"

panelModule.directive("nlgPanelHeaderButtons", [()=>{
    return {
        restrict: "E",
        template: panelView,
        transclude: true
    }
}])